import React from 'react';
import ViewHeader from './view-header';
import ViewContent from './view-content';
import SrMaxicomm from './reportesantonio';
import Otro from './reporte_ventas_clientes';


// styling
import './style.css';
import { connect } from 'react-redux';
import * as actions from '../../actions/auth';

class ModalTablas extends React.Component
{
	constructor(props)
	{
		super(props)

		this.state = {
		
        };
	}
	render()
	{
		let user= 0;//parseInt(this.props.user.user,10);

		
        if (typeof(this.props.auth.user) !="undefined")
        {           
            user= parseInt(this.props.auth.user.id);
       }
		return(

				<div className="view">
					<ViewHeader />
					{
						(user==15)&&<SrMaxicomm /> 
					}
					{
						(user > 0&&user!=15)&&<Otro /> 
					}
					
				</div>

			
		);
	}
}

function mapStateToProps(state, ownProps) {
    return {
        auth : state.auth,
    }
};

export default connect(mapStateToProps, actions)(ModalTablas)



// WEBPACK FOOTER //
// ./src/views/dashboard/index.js